import React, { useState, useEffect, useRef } from "react";
import { Control } from "react-redux-form";
import DatePicker from "react-datepicker";
import moment from "moment";
import { DropdownToggle, DropdownItem, DropdownMenu, UncontrolledDropdown } from "reactstrap";

const DueDatePicker = ({
  viewDateFormat = "YYYY-MM-DD",
  modelDateFormat = "YYYY-MM-DD",
  ...props
}) => {
  const [dueDateOptions, setDueDateOptions] = useState([]);
  useEffect(() => {
    const today = moment();
    const nextMonth = today.clone().add(1, 'month');
    const threeMonth = today.clone().add(3, 'month');
    const next10Days = today.clone().add(10, 'days');
    const nextWeek = today.clone().add(7, 'days');
    const tomorrow = today.clone().add(1, 'days');

    const options = [
      { label: `Tomorrow (${tomorrow.format(viewDateFormat)})`, value: tomorrow.format(modelDateFormat) },
      { label: `In One Week (${nextWeek.format(viewDateFormat)})`, value: nextWeek.format(modelDateFormat) },
      { label: `In 10 Days (${next10Days.format(viewDateFormat)})`, value: next10Days.format(modelDateFormat) },
      { label: `In One Month (${nextMonth.format(viewDateFormat)})`, value: nextMonth.format(modelDateFormat) },
      { label: `In Three Months (${threeMonth.format(viewDateFormat)})`, value: threeMonth.format(modelDateFormat) },

    ];

    setDueDateOptions(options);
  }, []);

  return (
 
        <Control.custom
          component={(ownProps) => {
            return (
              <div className="cnt row">
                <div className="dcnt col pr-0">
                  <div>
                    <DatePicker selected={ownProps.selected} onChange={(date) => ownProps.onChange(date)} className="form-control" dateFormat={viewDateFormat}/>
                  </div>
                </div>
                <div className="col-2 pl-0">
                  <UncontrolledDropdown>
                      <DropdownToggle caret className="btn btn-light" style={{ boxShadow: "none" }}></DropdownToggle>
                      <DropdownMenu right>
                        {
                          dueDateOptions.map((option) => (
                            <DropdownItem key={option.value} onClick={(e) => {
                              ownProps.onChange(moment(option.value));
                            }}
                            >{option.label}</DropdownItem>
                          ))}
                      </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            )
          }}
          mapProps={{
            selected: (ownProps) =>
              ownProps.modelValue ? moment(ownProps.modelValue) : moment(new Date()),
            onChange: (ownProps) => (value) => {
              const m = moment(value);
              return ownProps.onChange(
                m.isValid() ? m.format(modelDateFormat) : null
              );
            },
            onBlur: (ownProps) => ownProps.onBlur,
            onFocus: (ownProps) => ownProps.onFocus,
          }}
          dateFormat={viewDateFormat}
          autoComplete="off"
          {...props}
        />
  );
};

export default DueDatePicker;
